import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { initialTabs } from './constants';
import TabsPageLayout from '../../components/TabsPageLayout';
import { PORTAL_ROUTE } from '../../constants/routes';
import useQueryData from '../../queries/useQueryData';
import { CUSTOMER_QUERY_KEY, CUSTOMERS_QUERY_KEY, USER_QUERY_KEY } from '../../constants/query';
import { userRoleSelector } from '../../selectors/user';
import { Roles } from '../../constants/role';
import { customerIdSelector } from '../../selectors/customer';
import { customersPagesSelectors } from '../../selectors/customers';

const Company = () => {
  const role = useQueryData(USER_QUERY_KEY, userRoleSelector);
  const isSuperAdmin = role === Roles.superAdmin;
  const location = useLocation();
  const isCreateCompanyRoute = location.pathname === `${PORTAL_ROUTE}/company/create`;
  const navigate = useNavigate();
  const customerId = useQueryData(CUSTOMER_QUERY_KEY, customerIdSelector);
  const customersPages = useQueryData(CUSTOMERS_QUERY_KEY, customersPagesSelectors);
  const customersListCount = useMemo(() => {
    if (!customersPages?.length) return 0;

    return customersPages[0]?.customers?.length;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customersPages?.pages?.length]);

  const companyTabs = useMemo(
    () => [
      isCreateCompanyRoute && isSuperAdmin
        ? {
            label: 'Company Details',
            value: `${PORTAL_ROUTE}/company/create`,
          }
        : {
            label: 'Company Details',
            value: `${PORTAL_ROUTE}/company/details`,
          },
      ...initialTabs,
      ...(isSuperAdmin && !isCreateCompanyRoute
        ? [{ label: 'History', value: `${PORTAL_ROUTE}/company/history` }]
        : []),
    ],
    [isSuperAdmin, isCreateCompanyRoute],
  );

  useEffect(() => {
    if (!customerId && !customersListCount && location?.state?.from === '/login') {
      navigate(`${PORTAL_ROUTE}/companies`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId, customersListCount]);

  useEffect(() => {
    if (customerId && !customersListCount) {
      navigate(`${PORTAL_ROUTE}/companies`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId, customersListCount, location.pathname]);

  return <TabsPageLayout tabs={companyTabs} />;
};

export default Company;
